import { render, staticRenderFns } from "./planconvenionuevo.vue?vue&type=template&id=3993c8d0"
import script from "./planconvenionuevo.vue?vue&type=script&lang=js"
export * from "./planconvenionuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports